module.exports = __webpack_public_path__ + "img/001整体.4b60066e.jpg";